module.exports = __webpack_public_path__ + "img/symbol_6.83886b08.png";